// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatroomPage_wrapper__jirid","chatBoxClass":"ChatroomPage_chatBoxClass__c+4Jz"};